import { login, logout, getUserSectionInfoByToken } from '@/api/user'
import { getToken, setToken, removeToken, accessDenied } from '@/utils/auth'
import { resetRouter } from '@/router'
import { getUserPurchaseBrands } from "@/api/agency/common";
import {
    getAllProvince
  } from "@/api/agency/postage"

const getDefaultState = () => {
    return {
        token: getToken(),
        roles: [],
        salesman: [],
        name: "",
        realname: "",
        userId: "",
        layoutPath: "",
        wx: {},
        purchase: false,
        userBrands: [],
        province: []
    }
}

const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_SALESMAN: (state, salesman) => {
        state.salesman = salesman
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_REALNAME: (state, realname) => {
        state.realname = realname
    },
    SET_USERID: (state, userId) => {
        state.userId = userId
    },
    SET_LAYOUTPATH: (state, path) => {
        state.layoutPath = path
    },
    SET_WX: (state, wx) => {
        state.wx.wxIsbind = wx.wxIsbind
        state.wx.wxHeadImgUrl = wx.wxHeadImgUrl
    },
    SET_PURCHASE: (state, purchase) => {
        state.purchase = purchase
    },
    SET_USERBRANDS: (state, userBrands) => {
        state.userBrands = userBrands
    },
    set_PROVINCE: (state, province) => {
        state.province = province
    }
}

const actions = {
    // 登入
    login({ commit }, userInfo) {
        const { username, password, isManager } = userInfo
        return new Promise((resolve, reject) => {
            login({ username: username.trim(), password: password, isManager: isManager }).then(response => {
                // commit('SET_NAME', result.username)
                commit('SET_TOKEN', response.data.token)
                setToken(response.data.token);
                // setCookie(response.token)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 登出
    logout({ commit, state }) {
        return new Promise((resolve, reject) => {
            logout(state.token).then(() => {
                removeToken() // must remove  token  first
                resetRouter()
                    // dispatch('tagsView/delAllViews', null, { root: true })
                commit('RESET_STATE')
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 个人路由权限
    getUserSectionInfoByToken({ commit }, path) {
        let str = path
        return new Promise((resolve, reject) => {
            getUserSectionInfoByToken().then(response => {
                const { data } = response
                if (!data) {
                    reject('Verification failed, please Login again.')
                }
                const { id, username, realname, roleId, wxIsbind, wxHeadimgurl, salesman, purchase } = data
                const wx = { "wxIsbind": wxIsbind, "wxHeadImgUrl": wxHeadimgurl }
                commit('SET_ROLES', roleId)
                commit('SET_SALESMAN', salesman)
                commit('SET_NAME', username)
                commit('SET_REALNAME', realname)
                commit('SET_USERID', id)
                commit('SET_WX', wx)
                commit('SET_PURCHASE', purchase)
                accessDenied(str)
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 获取个人品牌
    getUserBrands({ commit }) {
        return new Promise((resolve, reject) => {
            getUserPurchaseBrands().then(res => {
                commit("SET_USERBRANDS", res.data)
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 获取所有省份
    getAllProvince({ commit }) {
        return new Promise((resolve, reject) => {
            getAllProvince().then(res => {
                commit("set_PROVINCE", res.data)
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 删除token
    resetToken({ commit }) {
        return new Promise(resolve => {
            removeToken() // must remove  token  first
            commit('RESET_STATE')
            resolve()
        })
    },
    layoutPathChange({ commit }, path) {
        return new Promise(resolve => {
            commit('SET_LAYOUTPATH', path)
            resolve()
        })
    },
}

export default {
    state,
    mutations,
    actions
}